<template>
  <v-container>
    <v-layout align-center justify-center>
      <h2 v-if="uploadReady" class="text-xs-center">Select a .csv file</h2>
      <h2 v-if="uploadReady && showDownloadTemplate" class="text-xs-center">  
        &nbsp;or <a @click="downloadTemplate">download template</a>
      </h2>
    </v-layout>
    <v-layout align-center justify-center>
      <input
        v-if="uploadReady"
        class="text-xs-center ml-5 pt-3"
        ref="inputUpload"
        type="file"
        @change="onFileChange"
        accept=".csv"
      />
    </v-layout>
    <!-- <v-layout align-center justify-center>
      <v-btn
        color="yellow darken-4"
        class="elevation-6"
        :loading="loading"
        large
        fab
        dark
        @click="uploadFile"
      >
        <v-icon>file_upload</v-icon>
      </v-btn>
    </v-layout>-->
    <v-layout align-center justify-center>
      <slot></slot>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    loading: Boolean,
    showDownloadTemplate: Boolean,
  },
  data() {
    return {
      downloadCsv: false,
      fileinput: "",
      uploadReady: true,
    };
  },
  computed: {},
  methods: {
    clear() {
      console.log("test");
      this.uploadReady = false;
      this.$nextTick(() => {
        this.uploadReady = true;
      });
    },
    async onFileChange(e) {
      this.clear();
      var files = e.target.files || e.dataTransfer.files;
      if (files[0] === undefined) {
        this.fileinput = "";
      }
      if (!files.length) return;
      await this.createInput(files[0]);

      // this.$emit("selectFile", await this.fileinput);
    },
    async createInput(file) {
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.fileinput = reader.result;

        vm.$emit("selectFile", reader.result);
      };
      await reader.readAsText(file);
    },
    uploadFile() {
      // this.$emit("selectFile", this.fileinput);
      this.clear();
    },
    downloadTemplate() {
      this.$emit("downloadTemplate");
    },
  },
};
</script>

<style></style>
